import { CommonModule } from '@angular/common'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { UnsuccessfulResponseInterceptor } from './shared/unsuccessful-response.interceptor'

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: UnsuccessfulResponseInterceptor, multi: true }],
})
export class MyCiceroWebApiModule {}
